import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyCJ5JZhaSu_Rpp1XE4XsOvTeHU_FFiz4tA",
  authDomain: "e-module-spermatophyta.firebaseapp.com",
  databaseURL: "https://e-module-spermatophyta.firebaseio.com",
  projectId: "e-module-spermatophyta",
  storageBucket: "e-module-spermatophyta.appspot.com",
  messagingSenderId: "99625680530",
  appId: "1:99625680530:web:4a1bd3d7d7fdb56910304b",
  measurementId: "G-417K21S449"
};

firebase.initializeApp(firebaseConfig)

const database = firebase.database()
const auth = firebase.auth()
const storage = firebase.storage()

export { database, auth, storage }